import { EnumModel } from "../Models/EnumModel";

export type ReactEnumItem = Readonly<{ id: string; name: string; value: number }>;
export type ReactEnumDefinition = Readonly<{ id: string; name: string; items: readonly ReactEnumItem[] }>;
export type ReactEnumContext = { get: (enumId: string) => ReactEnumDefinition };

export function createReactEnumContext(enums: readonly EnumModel[] = []): ReactEnumContext {
  const byId = new Map(enums.map((definition) => [definition.Id.toLowerCase(), Object.freeze({
    id: definition.Id,
    name: definition.Name,
    items: Object.freeze(definition.Items.map((item) => Object.freeze({ id: item.Id, name: item.Name, value: item.Value }))),
  })]));

  return Object.freeze({
    get: (enumId: string) => {
      const definition = byId.get(enumId.toLowerCase());
      if (!definition) {
        throw new Error(`Enum '${enumId}' is not included in this App bundle. Declare it in the React descriptor's EnumIds, compile/publish, and save the App.`);
      }
      return definition;
    },
  });
}
